import { render, staticRenderFns } from "./ImportData.vue?vue&type=template&id=7c630c9e&"
import script from "./ImportData.vue?vue&type=script&lang=js&"
export * from "./ImportData.vue?vue&type=script&lang=js&"
import style0 from "./ImportData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports